import common from './common';
import ncre from './ncre';
import search from './search';
import user from './user';
import course from './course';
import article from './article';
import deeplink from './deeplink';
import question from './question';
import enterprise from './enterprise';
import home from './home';
import skill from './skill';

export default {
  ...common,
  ...ncre,
  ...search,
  ...user,
  ...course,
  ...article,
  ...question,
  ...deeplink,
  ...enterprise,
  ...home,
  ...skill
};
